import instance from 'services/api';
import { toast } from 'react-toastify';
import {
  ADD_SECTION_POS,
  DELETE_SECTION_POS,
  GET_SECTION_POS,
  LAST_CREATED_SECTION_POS,
  SET_LOADING_POS,
  UPDATE_SECTION_POS,
} from 'redux/actions/types';
import { getTablePOS } from 'redux/actions/Pos/tables';
import {
  ensureSectionInVisualization,
  removeSectionFromVisualization,
  updateSectionInVisualization,
} from 'pages/PosSettings/FloorPlan/syncCatalogToVisualization';

const businessUuidFromState = (getState) =>
  getState()?.business?.currentBusiness?.uuid || '';

export const getSectionPOS = (businessuuid) => (dispatch, getState) => {
  const lastCreatedSectionId = getState().pos.lastCreatedSection;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .get(`/cloud-pos/section`, {
      headers: {
        businessUuid: businessuuid,
      },
    })
    .then((response) => {
      const data = response?.data?.data;
      if (lastCreatedSectionId) {
        const index = data.findIndex(
          (section) => section?.sectionDetails?.uuid === lastCreatedSectionId
        );
        console.log('data', data);
        if (index !== -1) {
          const [lastCreatedSection] = data.splice(index, 1);
          data.unshift(lastCreatedSection);
        }
      }
      dispatch({ type: GET_SECTION_POS, payload: data });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      return Promise.reject(err);
    });
};

export const createSectionPOS = (body) => (dispatch, getState) => {
  const sections = getState().pos.sections;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .post(`/cloud-pos/section`, body)
    .then(async (response) => {
      const data = response?.data?.data;
      const lastCreatedSectionId =
        response?.data?.data?.sectionDetails?.uuid || null;
      dispatch({
        type: LAST_CREATED_SECTION_POS,
        payload: lastCreatedSectionId,
      });
      const filterSections = sections.filter(
        (section) =>
          section?.sectionDetails?.uuid !== data?.sectionDetails?.uuid
      );
      filterSections.push(data);
      dispatch({ type: ADD_SECTION_POS, payload: filterSections?.reverse() });
      dispatch({ type: SET_LOADING_POS, payload: false });

      const businessUuid =
        body?.businessUuid || businessUuidFromState(getState);
      const details = data?.sectionDetails || {};
      await ensureSectionInVisualization({
        businessUuid,
        uuid: details.uuid || lastCreatedSectionId,
        name: details.name || body?.name,
        displayName: details.displayName || body?.displayName || body?.name,
      });

      dispatch(getTablePOS(businessUuid));
      dispatch(getSectionPOS(businessUuid));
      return filterSections;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message?.message || '');
      dispatch({ type: SET_LOADING_POS, payload: false });
      return Promise.reject(err);
    });
};

export const updateSectionPOS = (dataReq) => (dispatch, getState) => {
  dispatch({ type: SET_LOADING_POS, payload: true });
  const sections = getState().pos.sections;
  return instance
    .patch(`/cloud-pos/section/${dataReq.sectionId}`, dataReq.body)
    .then(async (response) => {
      const data = response?.data?.data;
      const findIndex = sections.findIndex((section) => {
        return section.sectionDetails?.uuid === dataReq.sectionId;
      });
      if (findIndex !== -1) {
        sections[findIndex] = data;
      }
      dispatch({ type: UPDATE_SECTION_POS, payload: sections });
      toast.success('Update section has been successfully!');
      dispatch({ type: SET_LOADING_POS, payload: false });

      const businessUuid =
        dataReq.body?.businessUuid || businessUuidFromState(getState);
      const details = data?.sectionDetails || {};
      await updateSectionInVisualization({
        businessUuid,
        uuid: dataReq.sectionId,
        name: details.name || dataReq.body?.name,
        displayName:
          details.displayName ||
          dataReq.body?.displayName ||
          dataReq.body?.name,
      });

      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      toast.error(err?.response?.data?.message?.message || '');
      return Promise.reject(err);
    });
};

export const deleteSectionPOS = (sectionId) => (dispatch, getState) => {
  const sections = getState().pos.sections;
  const tables = getState().pos.tables || [];
  const businessUuid = businessUuidFromState(getState);
  dispatch({ type: SET_LOADING_POS, payload: true });

  // Cascade child tables first so section DELETE is not blocked / orphaned.
  const childTableUuids = tables
    .map((table) => table?.tableDetails)
    .filter((details) => details?.sectionUuid === sectionId && details?.uuid)
    .map((details) => details.uuid);

  const deleteChildren = Promise.all(
    childTableUuids.map((tableUuid) =>
      instance.delete(`/cloud-pos/table/${tableUuid}`).catch(() => null)
    )
  );

  return deleteChildren
    .then(() => instance.delete(`/cloud-pos/section/${sectionId}`))
    .then(async () => {
      const filterTabled = sections.filter(
        (section) => section?.sectionDetails?.uuid !== sectionId
      );
      dispatch({ type: DELETE_SECTION_POS, payload: filterTabled });
      dispatch({ type: SET_LOADING_POS, payload: false });

      await removeSectionFromVisualization({
        businessUuid,
        uuid: sectionId,
      });

      if (businessUuid) {
        dispatch(getTablePOS(businessUuid));
        dispatch(getSectionPOS(businessUuid));
      }

      return filterTabled;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      return Promise.reject(err);
    });
};
